<template>
  <form>
    <div class="search-wrap">
      <!--      <button type="button" @click="getStore()"> Store Test</button>-->
      <!-- Hab hier input und label vertauscht...laut Internet muss das so es geht aber nicht..Anzeigefehler     -->
      <input type="text" v-on:keyup.enter="this.search" class="form-control" v-model="filmTitle" >
      <label class="search-criteria">Title</label>
      <input type="text" v-on:keyup.enter="this.search" class="form-control" v-model="director">
      <label class="search-criteria">Director</label>
      <input type="text" v-on:keyup.enter="this.search" class="form-control" v-model="cast">
      <label class="search-criteria">Cast</label>
      <input type="text" v-on:keyup.enter="this.search" class="form-control" v-model="productionCompany">
      <label class="search-criteria">Production Company</label>
      <input type="text" v-on:keyup.enter="this.search" class="form-control" v-model="language">
      <label class="search-criteria">Language</label>
      <input type="text" v-on:keyup.enter="this.search" class="form-control" v-model="worldSales">
      <label class="search-criteria">World Sales</label>
      <input type="text" v-on:keyup.enter="this.search" class="form-control" v-model="cinematographer">
      <label class="search-criteria">Cinematographer</label>
      <input type="text" v-on:keyup.enter="this.search" class="form-control" v-model="screenwriter">
      <label class="search-criteria">Screenwriter</label>
      <div class="genre">
        <div class="extend-searchbar" @click="this.extendGenres">
          <label class="search-criteria" >Genre</label>
          <span id="filmgenre" class="icon-plus_im_kreis"/>
        </div>
        <div class="form-group">
          <div id="genre-box" class="checkbox-container">
            <div v-for="genre in this.$store.state.allGenres" :key="genre.uid">
              <input type="checkbox" :id="'gen'+genre.uid" :value="genre.uid" v-model="checkedGenre">
              <label :for="'gen'+genre.uid"> {{ genre.title }}</label><br>
            </div>
<!--            <span @click="this.extendGenres" class="icon-x_im_kreis"/>-->
          </div>
        </div>
      </div>
      <div class="category">
        <div class="extend-searchbar" @click="this.extendCategories">
          <label class="search-criteria">Category</label>
          <span id="filmcategory" class="icon-plus_im_kreis"/>
        </div>
        <div class="form-group">
          <div id="category-box" class="checkbox-container">
            <div v-for="category in this.$store.state.allCategories" :key="category.uid">
              <input type="checkbox" :id="'cat'+category.uid" :value="category.uid"
                     v-model="checkedCategory">
              <label :for="'cat'+category.uid"> {{ category.title }}</label><br>
            </div>
<!--            <span @click="this.extendCategories" class="icon-x_im_kreis"/>-->
          </div>
        </div>
      </div>
      <div class="date">
        <div class="form-group">
          <label class="search-criteria">Year of production</label>
          <div class="year-wrapper">
            <span id="numbers">
              <input id="start-date-box" v-model="startDateBox" type="number" readonly/>
              <input id="end-date-box" v-model="endDateBox" type="number" readonly/>
            </span>
            <div class="range-slider">
              <input class="slider" id="start-date-slider" v-model="startDate" step="1" type="range"/>
              <input class="slider" id="end-date-slider" v-model="endDate" step="1" type="range"/>
            </div>
          </div>
        </div>
      </div>
      <div class="searchbar-footerline">
        <div id="searchbar-buttons" @click="this.search">
          <span class="link-arrow">Search</span>
        </div>
      </div>
    </div>
  </form>
</template>

<script>

export default {
  /*
TODO Suche:
    - Screenwriter Suche geht nicht -> Rolle existiert nicht in der DB
    - Safari search button ist auf der linken Seite
      */
  data() {
    return {
      hostname: this.$store.state.hostname,
      prefix: `${this.$store.state.extensionName}_${this.$store.state.pluginName}`,
      screenwriter: '',
      splitScreenwriter: '',
      cinematographer: '',
      splitCinematographer: '',
      filmTitle: '',
      director: '',
      splitDirector: '',
      cast: '',
      splitCast: '',
      language: '',
      splitLanguage: '', // auswählbar machen?
      productionCompany: '',
      splitProductionCompany: '',
      worldSales: '',
      splitWorldSales: '',
      checkedCategory: [],
      checkedGenre: [],
      startDate: '', // TODO Für Relaunch Parse int
      endDate: '',
      showMoreFilters: 0,
      showMoreFiltersText: 'Mehr Filter anzeigen',
      countIncrease: 20,
      startDateBox: 0,
      endDateBox: 0,
      filmid: 0,
      personid: 0,
      companyid: 0,
      preview: false,
    };
  },
  methods: {
    async fetchOldestFilm() {
      // Datum des ältesten Films wird für den niedrigsten möglichen Wert des Sliders benötigt
      // Genres und Kategorien für die Checkboxen werden Dynamisch aus den Ergebnissen dieses Fetches aufgelistet
      await fetch(
        `https://${this.hostname}/?&${this.prefix}[filter][answerType]=initial&type=2753189517`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        },
      )
        .then((response) => response.json())
        .then((data) => {
          // hier wird die Mutation "updateOldestFilm" benutzt um den im Store gespeicherten wert zu überschreiben
          // Mutations werden so aufgerufen
          // mit this.$store wird der Store angesprochen -> src/store/index.js
          // Mit commit('<mutationName>', <data>) wird eine Mutation angestoßen
          this.$store.commit('updateOldestFilm', data.oldestFilm);
          this.$store.commit('updateAllGenres', data.genre);
          this.$store.commit('updateAllCategories', data.category);
        }).catch(() => {
          this.$store.commit('completeLoading', true);
          this.$store.commit('updateError', 1);
        });
    },
    initiateSlider() {
      // Iniziiert den Slider
      // Der Slider besteht aus 2 Readonly boxen für die Jahreszahlen, und aus 2 Inputs type="slider" die übereinander gelagert sind
      // Hier werden die Slider mit den Boxen Synchronisiert
      const currentYear = new Date().getFullYear();
      const oldestFilmDate = this.$store.state.oldestFilm;
      this.startDate = oldestFilmDate;
      this.endDate = currentYear;
      this.startDateBox = oldestFilmDate;
      this.endDateBox = currentYear;
      const items = [];
      items.push(document.getElementById('start-date-box'));
      items.push(document.getElementById('end-date-box'));
      items.push(document.getElementById('start-date-slider'));
      items.push(document.getElementById('end-date-slider'));
      items.forEach((element) => {
        element.setAttribute('max', `${currentYear}`);
        element.setAttribute('min', `${oldestFilmDate}`);
      });
      document.getElementById('end-date-slider').setAttribute('value', `${currentYear}`);
      const parent = document.querySelector('.range-slider');
      if (!parent) return;

      const
        rangeS = parent.querySelectorAll('input[type=range]');
      const numberS = document.getElementById('numbers').querySelectorAll('input[type=number]');

      rangeS.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.oninput = function () {
          let slide1 = parseFloat(rangeS[0].value);
          let slide2 = parseFloat(rangeS[1].value);

          if (slide1 > slide2) {
            [slide1, slide2] = [slide2, slide1];
            // var tmp = slide2;
            // slide2 = slide1;
            // slide1 = tmp;
          }

          numberS[0].value = slide1;
          numberS[1].value = slide2;
        };
      });

      numberS.forEach((el) => {
        // eslint-disable-next-line no-param-reassign
        el.oninput = function () {
          const number1 = parseFloat(numberS[0].value);
          const number2 = parseFloat(numberS[1].value);

          if (number1 > number2) {
            const tmp = number1;
            numberS[0].value = number2;
            numberS[1].value = tmp;
          }

          rangeS[0].value = number1;
          rangeS[1].value = number2;
        };
      });
    },
    extendCategories() {
      // Methode um Kategorien auszuklappen
      // Funktioniert über die vergabe von Klassen
      // Über die klassen 'icon-minus_im_kreis' und 'icon-plus_im_kreis wird' das '+' bzw '-' Icon gesetzt
      const categoryBox = document.getElementById('category-box');
      const categoryIcon = document.getElementById('filmcategory');
      const genreBox = document.getElementById('genre-box');
      const genreIcon = document.getElementById('filmgenre');
      if (genreBox.classList.contains('extend-checkboxes')) {
        genreBox.classList.remove('extend-checkboxes');
        genreIcon.classList.remove('icon-minus_im_kreis');
        genreIcon.classList.add('icon-plus_im_kreis');
      }
      if (categoryBox.classList.contains('extend-checkboxes')) {
        categoryBox.classList.remove('extend-checkboxes');
        categoryIcon.classList.remove('icon-minus_im_kreis');
        categoryIcon.classList.add('icon-plus_im_kreis');
        return;
      }
      categoryBox.classList.add('extend-checkboxes');
      categoryIcon.classList.remove('icon-plus_im_kreis');
      categoryIcon.classList.add('icon-minus_im_kreis');
    },
    extendGenres() {
      // Methode um Genres auszuklappen
      // Siehe extendCategories
      const categoryBox = document.getElementById('category-box');
      const categoryIcon = document.getElementById('filmcategory');
      const genreBox = document.getElementById('genre-box');
      const genreIcon = document.getElementById('filmgenre');
      if (categoryBox.classList.contains('extend-checkboxes')) {
        categoryBox.classList.remove('extend-checkboxes');
        categoryIcon.classList.remove('icon-minus_im_kreis');
        categoryIcon.classList.add('icon-plus_im_kreis');
      }
      if (genreBox.classList.contains('extend-checkboxes')) {
        genreBox.classList.remove('extend-checkboxes');
        genreIcon.classList.remove('icon-minus_im_kreis');
        genreIcon.classList.add('icon-plus_im_kreis');
        return;
      }
      genreBox.classList.add('extend-checkboxes');
      genreIcon.classList.remove('icon-plus_im_kreis');
      genreIcon.classList.add('icon-minus_im_kreis');
    },
    async search() {
      // Wird aufgerufen beim Suchen
      // Die Variable die hier verändert wird entscheidet darüber ob ein Ergebnis angezeigt wird oder nicht
      // wenn completeLoading auf false steht werden die 3 Roten Ladepunkte in der Mitte angezeigt
      // Wenn scheinbar ewig geladen wird -> die Ladepunkte verschwinden nicht, dann ist diese Funktion vermutlich in der Mitte abgebrochen worden
      if (this.$store.state.preview) {
        await this.$store.commit('completeLoading', true);
        return;
      }
      this.$store.commit('completeLoading', false);
      if (this.filmid === 0) {
        await this.$store.commit('clearEntries');
      }
      // mit "await" verhindert man dass Prozesse Parallel ausgeführt werden
      // Um "await" zu benutzen muss die methode asynchron sein -> async vor dem Methodennamen
      await this.$store.commit('updateError', 0);
      await this.$store.commit('updateCounter', 0);
      await this.fetchIdArray();
      if (await this.nextItems()) {
        await this.fetchItems();
      }
      if (this.filmid === 0 && this.personid === 0 && this.companyid === 0) {
        await this.$router.push({ path: this.$store.state.site, query: await this.buildVueURL() });
      } else {
        this.filmid = 0;
      }
      await this.$store.commit('completeLoading', true);
    },
    async buildControllerURL() {
      // Baut eine URL zusammen mit der die Suchparameter an den Filmcontroller übergeben werden
      if (this.startDate > this.endDate) {
        // eslint-disable-next-line prefer-destructuring
        this.startDate = [this.endDate, this.endDate = this.startDate][0];
      }
      let URLParams = `https://${this.hostname}/?&`;
      if (this.checkedGenre.length > 0) {
        URLParams += `${this.prefix}[filter][genre]=${this.checkedGenre}&`;
      }
      if (this.checkedCategory.length > 0) {
        URLParams += `${this.prefix}[filter][category]=${this.checkedCategory}&`;
      }
      // eslint-disable-next-line eqeqeq
      if (this.startDate == this.$store.state.oldestFilm && this.endDate == new Date().getFullYear()) {
        URLParams += `${this.prefix}[filter][startDate]=undefined&`;
        URLParams += `${this.prefix}[filter][endDate]=undefined&`;
      } else {
        URLParams += `${this.prefix}[filter][startDate]=${this.startDate}&`;
        URLParams += `${this.prefix}[filter][endDate]=${this.endDate}&`;
      }
      if (this.filmTitle !== '') {
        URLParams += `${this.prefix}[filter][filmTitle]=${this.filmTitle}&`;
      }
      if (this.splitDirector !== '') {
        URLParams += `${this.prefix}[filter][director]=${this.splitDirector}&`;
      }
      if (this.splitProductionCompany !== '') {
        URLParams += `${this.prefix}[filter][productionCompany]=${this.splitProductionCompany}&`;
      }
      if (this.splitWorldSales !== '') {
        URLParams += `${this.prefix}[filter][worldSales]=${this.splitWorldSales}&`;
      }
      if (this.splitCast !== '') {
        URLParams += `${this.prefix}[filter][cast]=${this.splitCast}&`;
      }
      if (this.splitScreenwriter !== '') {
        URLParams += `${this.prefix}[filter][screenwriter]=${this.splitScreenwriter}&`;
      }
      if (this.splitLanguage !== '') {
        URLParams += `${this.prefix}[filter][language]=${this.splitLanguage}&`;
      }
      if (this.splitCinematographer !== '') {
        URLParams += `${this.prefix}[filter][cinematographer]=${this.splitCinematographer}&`;
      }
      if (this.$store.state.sortCriteria) {
        URLParams += `${this.prefix}[filter][sortCriteria]=${this.$store.state.sortCriteria}&`;
      } else {
        URLParams += `${this.prefix}[filter][sortCriteria]=title_en,title_de,asc&`;
      }
      URLParams += `${this.prefix}[filter][answerType]=IDs&`;
      URLParams += 'type=2753189517';
      this.$store.commit('updateURL', URLParams);
      return URLParams;
    },
    checkUserInput() {
      // Überprüft ob der Benutzer nicht zulässige Zeichen in die Text-Suchfelder eingetragen hat
      // wenn ja werden diese Zeichen direkt gelöscht
      this.filmTitle = this.filmTitle.replace(/[^a-zA-Z0-9\-\s\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]+/, '');
      this.screenwriter = this.screenwriter.replace(/[^a-zA-Z\-\s\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]+/, '');
      this.cinematographer = this.cinematographer.replace(/[^a-zA-Z\-\s\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]+/, '');
      this.director = this.director.replace(/[^a-zA-Z\-\s\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]+/, '');
      this.cast = this.cast.replace(/[^a-zA-Z\-\s\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]+/, '');
      this.language = this.language.replace(/[^a-zA-Z\-\s\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]+/, '');
      this.productionCompany = this.productionCompany.replace(/[^a-zA-Z\-\s\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]+/, '');
      this.worldSales = this.worldSales.replace(/[^a-zA-Z\-\s\u00c4\u00e4\u00d6\u00f6\u00dc\u00fc\u00df]+/, '');
    },
    separateStrings() {
      // Bearbeitung der vom Benutzer eingegebenen Strings um sie weiterzu verarbeiten -> für die URL die in BuildControllerURL gebaut wird
      // Doppelte Leerzeichen werden gelöscht, und Leerzeichen zu Kommas
      this.splitScreenwriter = this.screenwriter.replace(/\s\s+/g, ' ').replace(/\s+/g, ',').trim();
      this.splitCinematographer = this.cinematographer.replace(/\s\s+/g, ' ').replace(/\s+/g, ',').trim();
      this.splitDirector = this.director.replace(/\s\s+/g, ' ').replace(/\s+/g, ',').trim();
      this.splitCast = this.cast.replace(/\s\s+/g, ' ').replace(/\s+/g, ',').trim();
      this.splitLanguage = this.language.replace(/\s\s+/g, ' ').replace(/\s+/g, ',').trim();
      this.splitProductionCompany = this.productionCompany.replace(/\s\s+/g, ' ').replace(/\s+/g, ',').trim();
      this.splitWorldSales = this.worldSales.replace(/\s\s+/g, ' ').replace(/\s+/g, ',').trim();
    },
    async fetchItems() {
      await fetch(
        //  mit dem Answer Type [answerType]=items und der Übergabe eines Arrays das IDs enthält [items]=${await this.nextItems()} werden die Daten zu Filmen geladen
        `https://${this.hostname}/?&${this.prefix}[filter][answerType]=items&${this.prefix}[items]=${await this.nextItems()}&type=2753189517`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        },
      )
        .then((response) => response.json())
        .then(async (data) => {
          await this.$store.commit('updateWholeDatabase', data.itemList);
        }).catch(() => {
          this.$store.commit('completeLoading', true);
          this.$store.commit('updateError', 1);
        });
    },
    async fetchIdArray() {
      // Fordert ein Array mit IDs von Filmen an, die zu den eingegebenen Suchkriterien passen
      // Bei diesem Fetch werden keine Filmdaten geladen, sondern ausschließlich die IDs
      // Die Filmdaten werden in fetchItems geladen
      await fetch(
        await this.buildControllerURL(),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
        },
      )
        .then((response) => response.json())
        .then(async (data) => {
          await this.$store.commit('updateIdForSearchRequest', data.matchingIDs);
        }).catch(() => {
          this.$store.commit('completeLoading', true);
          this.$store.commit('updateError', 1);
        });
    },
    async nextItems() {
      // Hilfsfunktion von fetchItems()
      // Sucht die nächsten filmIDs raus anhand der passsenden FilmIDs die mit fetchIdArray abgefragt wurden
      if (this.$store.state.idForSearchRequest.length === 0) {
        return null;
      }
      const tempArray = [];
      for (let i = 0; i < this.countIncrease; i += 1) {
        if (this.$store.state.idForSearchRequest[this.$store.state.counter + i] != null) {
          tempArray.push(this.$store.state.idForSearchRequest[this.$store.state.counter + i]);
        }
      }
      // this.$store.commit('updateCounter', this.countIncrease);
      return tempArray;
    },
    async buildVueURL() {
      // die URL die hier gebaut wird ist später in der URL-Zeile des Browsers zu sehen
      // damit kann man den Link zu einer Suche verschicken oder abspeichern
      if (this.startDate > this.endDate) {
        // eslint-disable-next-line prefer-destructuring
        this.startDate = [this.endDate, this.endDate = this.startDate][0];
      }
      const URLParams = [];
      if (this.checkedGenre.length > 0) {
        URLParams.checkedGenre = this.checkedGenre.toString();
      }
      if (this.checkedCategory.length > 0) {
        URLParams.checkedCategory = this.checkedCategory.toString();
      }
      // eslint-disable-next-line eqeqeq
      if (this.startDate != this.$store.state.oldestFilm || this.endDate != new Date().getFullYear()) {
        URLParams.startDate = this.startDate;
        URLParams.endDate = this.endDate;
      }
      if (this.filmTitle !== '') {
        URLParams.filmTitle = this.filmTitle;
      }
      if (this.splitDirector !== '') {
        URLParams.director = this.splitDirector;
      }
      if (this.splitProductionCompany !== '') {
        URLParams.productionCompany = this.splitProductionCompany;
      }
      if (this.splitWorldSales !== '') {
        URLParams.worldSales = this.splitWorldSales;
      }
      if (this.splitCast !== '') {
        URLParams.cast = this.splitCast;
      }
      if (this.splitScreenwriter !== '') {
        URLParams.screenwriter = this.splitScreenwriter;
      }
      if (this.splitLanguage !== '') {
        URLParams.language = this.splitLanguage;
      }
      if (this.splitCinematographer !== '') {
        URLParams.cinematographer = this.splitCinematographer;
      }
      if (this.$store.state.sortCriteria) {
        URLParams.sortCriteria = this.$store.state.sortCriteria;
      } else {
        URLParams.sortCriteria = 'title_en,asc';
      }
      await this.$store.commit('updateVueURL', URLParams);
      return URLParams;
    },
    async readVueURL() {
      // Das gegenstück zu buildVueURL: die URL die dort gebaut wird wird beim Seitenaufruf hier ausgelesen.
      // Übergebene Parameter werden abgespeichert, angezeigt und in die initiale Suche eingebaut
      if (this.$route.query.showPreview) {
        const regExp = /[a-zA-Z]/g;
        if (regExp.test(this.$route.query.showPreview)) {
          window.location.href = '/404';
        } else {
          // eslint-disable-next-line radix
          this.filmid = parseInt(this.$route.query.showPreview);
        }
        this.preview = true;
        return;
      }
      if (this.$route.query.show) {
        const regExp = /[a-zA-Z]/g;
        if (regExp.test(this.$route.query.show)) {
          window.location.href = '/404';
        } else {
          // eslint-disable-next-line radix
          this.filmid = parseInt(this.$route.query.show);
        }
        return;
      }
      if (this.$route.query.person) {
        const regExp = /[a-zA-Z]/g;
        if (regExp.test(this.$route.query.person)) {
          window.location.href = '/404';
        } else {
          // eslint-disable-next-line radix
          this.personid = parseInt(this.$route.query.person);
        }
        return;
      }
      if (this.$route.query.company) {
        const regExp = /[a-zA-Z]/g;
        if (regExp.test(this.$route.query.company)) {
          window.location.href = '/404';
        } else {
          // eslint-disable-next-line radix
          this.companyid = parseInt(this.$route.query.company);
        }
        return;
      }
      if (this.$route.query.checkedGenre) {
        this.checkedGenre = this.$route.query.checkedGenre.split(',');
      }
      if (this.$route.query.checkedCategory) {
        this.checkedCategory = this.$route.query.checkedCategory.split(',');
      }
      if (this.$route.query.startDate) {
        this.startDate = this.$route.query.startDate;
      }
      if (this.$route.query.endDate) {
        this.endDate = this.$route.query.endDate;
      }
      if (this.$route.query.filmTitle) {
        this.filmTitle = this.$route.query.filmTitle;
      }
      if (this.$route.query.director) {
        this.director = this.$route.query.director.replace(',', ' ');
      }
      if (this.$route.query.productionCompany) {
        this.productionCompany = this.$route.query.productionCompany.replace(',', ' ');
      }
      if (this.$route.query.worldSales) {
        this.worldSales = this.$route.query.worldSales.replace(',', ' ');
      }
      if (this.$route.query.cast) {
        this.cast = this.$route.query.cast.replace(',', ' ');
      }
      if (this.$route.query.screenwriter) {
        this.screenwriter = this.$route.query.screenwriter.replace(',', ' ');
      }
      if (this.$route.query.language) {
        this.language = this.$route.query.language.replace(',', ' ');
      }
      if (this.$route.query.cinematographer) {
        this.cinematographer = this.$route.query.cinematographer.replace(',', ' ');
      }
      if (this.$route.query.sortCriteria) {
        this.$store.commit('updateSortCriteria', this.$route.query.sortCriteria);
      }
    },
    async showModal() {
      // Methode um einen Film, eine Person oder eine Firma anzuzeigen, falls die Seite mit einem entsprechenden Parameter aufgerufen wurde
      if (this.filmid !== 0) {
        if (this.preview) {
          await this.$store.commit('updatePreview', this.preview);
        }
        await this.$store.commit('updateSelectedFilmCard', this.filmid);
      }
      if (this.personid !== 0) {
        await this.$store.commit('updateSelectedPersonCard', this.personid);
      }
      if (this.companyid !== 0) {
        await this.$store.commit('updateSelectedCompanyCard', this.companyid);
      }
    },
  },
  // es folgen Lifecycle Hooks
  // das sind Methoden die immer zu bestimmten Aktionen ausgeführt werden
  updated() {
    // Sobald sich irgendetwas in dieser Komponente ändert wird dieser Hook ausgeführt
    this.checkUserInput();
    this.separateStrings();
  },
  async created() {
    // Beim Seitenaufruf wurd dieser Hook ausgeführt
    // die Index.html in der das CSS File sonst angfezogen wird kann nicht verwendet werden, daher wird hier das css File reingemogelt
    const head = document.getElementsByTagName('HEAD')[0];
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = `https://${this.hostname}/typo3conf/ext/sn_movie_db/Resources/Public/Css/styles.css`;
    head.appendChild(link);
    await this.fetchOldestFilm();
    await this.initiateSlider();
    await this.$store.commit('updateSite', this.$route.fullPath);
    await this.readVueURL();
    await this.showModal();
    await this.search();
    this.$watch('$store.state.sortCriteria', async function () {
      await this.search();
    });
  },
  // ein Watcher kann beobachten ob sich Variablen in anderen Komponenten ändern
  watch: {
    // Dieser Watcher beobachtet die im store gespeicherte Variable counter
    // diese wird verändert sobald der user auf "show more" klickt, dann sollen mehr Filme geladen werden
    '$store.state.counter': async function () {
      await this.fetchItems();
    },
  },
};
</script>

<style >

@media print{
  * {
    margin: 0 !important;
  }
  .wrap-back-button, .wrap-print-button, h1, h2, h3, h4, h5, .carousel, .topbar, #page-header, .breadcrumb-section, #page-footer{
    display: none !important;
  }
  .wrap-modal{
    margin: 0;
  }
  .modal-backdrop{
    display: block;
    position: static;
    height: unset;
    margin: 0;
  }
  .modal{
    position: static;
    top: 0;
    margin: 0;
    width: 100%;
    display: block;
    overflow-x: hidden;
    overflow-y: unset;
    height: 100%;
    margin-top: 0;
  }
  .filmliste, .searchbar{
    overflow: hidden !important;
    height: 0 !important;
  }
  #app{
    position: absolute;
  }
}

.date .form-group .search-criteria{
  font-size: 1rem;
  font-weight: bold;
  line-height: 1rem;
}

#start-date-box{
  text-align: left;
}

#end-date-box{
  text-align: right;
}
.range-slider {
  flex-direction: column;
  width: calc(100% - 25px);
  position: relative;
  height: .6rem;
  display: flex;
  justify-content: center;
}
.year-wrapper span{
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.slider{
  margin: 0;
  padding: 0;
  border: 0;
  outline: none;
  background: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 100%;
  height: 0;
  pointer-events: none;
  position: absolute;
  left: 0;
  bottom: 0;
  /* als alternative ausblenden? */
  -ms-overflow-style: -ms-autohiding-scrollbar;
}
.slider:focus {
  outline: none;
}
.slider::-webkit-slider-runnable-track {
  outline: 0;
  -webkit-appearance: none;
  background: #3c3c3c;
  height: 5px;
  cursor: pointer;
  border-radius: 1px;
  box-shadow: none;
  border: 0;
}
.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  pointer-events: auto;
  z-index: 2;
  position: relative;
  height: 18px;
  width: 18px;
  border-radius: 25px;
  background: #3c3c3c;
  cursor: pointer;
  margin-top: -7px;
}
.slider::-moz-range-track {
  cursor: default;
  -moz-appearance: none;
  outline: 0;
  height: 5px;
  background: #3c3c3c;
}
.slider::-moz-range-thumb {
  z-index: 2;
  -moz-appearance: none;
  pointer-events: auto;
  background: #3c3c3c;
}
/* Funktion muss überprüft werden */
.slider::-ms-track{
  height: 5px;
  background: #3c3c3c;
}
.slider::-ms-thumb{
  z-index: 2;
  pointer-events: auto;
  background: #3c3c3c;
}

#end-date-slider.slider::-moz-range-track{
  background: transparent;
/*  Das muss so; sonst sieht der Slider im Firefox seltsam aus*/
}

.genre .form-group::-webkit-scrollbar-thumb, .category  .form-group::-webkit-scrollbar-thumb {
  background: #ffffff !important;
  border-radius: 5px;
}
.genre .form-group::-webkit-scrollbar-track, .category .form-group::-webkit-scrollbar-track {
  border-radius: 5px;
  background: #ff0000 !important;
  border: 2px solid #3c3c3c;
}
.genre .form-group::-webkit-scrollbar, .category .form-group::-webkit-scrollbar {
  width: 10px;
}

.genre .form-group, .category .form-group{
  scrollbar-width: 10px;
  scrollbar-color: #fff rgba(0, 0, 0, 0.17);
}
</style>
